import styled, { css } from 'styled-components';

import { IconCross } from '@xing-com/icons';
import { PopOver as BreweryPopOver } from '@xing-com/pop-over';
import {
  spaceL,
  spaceXL,
  spaceXXL,
  xdlColorPremiumTertiary,
  xdlColorText,
} from '@xing-com/tokens';

const PopOver = styled(BreweryPopOver)<{ $premiumTheme: boolean }>`
  padding: 0;
  z-index: 51;

  ${({ $premiumTheme }) =>
    $premiumTheme &&
    css`
      background: ${xdlColorPremiumTertiary};
    `}
`;

const PopOverContentContainer = styled.div`
  padding: ${spaceXL} ${spaceXXL} ${spaceXL} ${spaceXL};
  width: 380px;

  & p:last-of-type {
    margin-bottom: ${spaceL};
  }
`;

const CloseButton = styled(IconCross)`
  color: ${xdlColorText};
  cursor: pointer;
  height: 24px;
  position: absolute;
  right: 15px;
  top: 15px;
  width: 24px;
`;

const PopOverContent = styled.div`
  width: 100%;
`;

export const Styled = {
  PopOver,
  PopOverContentContainer,
  CloseButton,
  PopOverContent,
};
